import { State } from '../StateTypes';
import {
  DraggingWallResizer,
  MeasurementsActive,
  Room,
  Scene,
  SceneRect,
  WallResizerActive,
} from './sceneTypes';

/**
 * Select scene state slice
 *
 * @param scene
 */
export const selectScene = ({ scene }: State): Scene => scene;

/**
 * Select is wall resizer active
 *
 * @param state
 * @returns {*}
 */
export const selectIsWallResizerActive = (state: State): WallResizerActive =>
  selectScene(state).wallResizerActive;

/**
 * Select is measurements active
 *
 * @param state
 * @returns {*}
 */
export const selectIsMeasurementsActive = (state: State): MeasurementsActive =>
  selectScene(state).measurementsActive;

/**
 * Select dragging wall resizer
 *
 * @param state
 * @returns {Requireable<boolean> | boolean}
 */
export const selectDraggingWallResizer = (state: State): DraggingWallResizer =>
  selectScene(state).draggingWallResizer;

/**
 * Select room
 *
 * @param state
 * @returns {*}
 */
export const selectRoom = (state: State): Room => selectScene(state).room;

export const selectMinRoom = (state: State): Room => selectRoom(state).minRoom;

export const selectSceneRect = (state: State): SceneRect =>
  selectRoom(state).sceneRect;

export const selectSceneMargins = (state: State): SceneRect =>
  selectRoom(state).margins;
/**
 * Select preloadDone state slice
 *
 * @param state
 */
export const selectHasScenePreloadFinished = (state: State) =>
  selectScene(state).preloadDone;

/**
 * Select show scene sheet
 *
 * @param state
 */
export const selectShowSceneSheet = (state: State) =>
  selectScene(state).sceneSheet.showSceneSheet;

/**
 * Select scene sheet variant
 * @param state
 */
export const selectSceneSheetVariant = (state: State) =>
  selectScene(state).sceneSheet.sceneSheetModel;
